import * as React from 'react';
const SvgCurrencyPound = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M6.63 16.667a.6.6 0 0 1-.447-.183.6.6 0 0 1-.183-.447v-.252a.6.6 0 0 1 .057-.262.8.8 0 0 1 .158-.233q.855-.743 1.32-1.31T8 12.19q0-.213-.02-.42a2 2 0 0 0-.087-.411H6.542a.52.52 0 0 1-.383-.159.52.52 0 0 1-.159-.383q0-.224.159-.383a.52.52 0 0 1 .383-.158h.807q-.778-.99-1.064-1.76A4.2 4.2 0 0 1 6 7.062q0-1.725 1.17-2.894T10.02 3q1.116 0 2.019.529A4.1 4.1 0 0 1 13.5 4.994a.49.49 0 0 1 .052.432.48.48 0 0 1-.286.32.47.47 0 0 1-.39.016.64.64 0 0 1-.317-.262 3.2 3.2 0 0 0-1.086-1.034 2.84 2.84 0 0 0-1.452-.383q-1.234 0-2.086.852A2.8 2.8 0 0 0 7.083 7q0 .765.401 1.513.4.748 1.162 1.763h2.896q.225 0 .383.158a.52.52 0 0 1 .158.383q0 .224-.158.383a.52.52 0 0 1-.383.159H8.997q.05.261.068.46.018.198.018.476 0 .924-.382 1.77a4.7 4.7 0 0 1-1.118 1.518h4.709q.59 0 .978-.306.389-.306.604-.918a.6.6 0 0 1 .213-.312.57.57 0 0 1 .349-.11q.216 0 .39.16.172.158.172.374 0 .94-.939 1.568-.939.627-1.767.628z'
            />
        </g>
    </svg>
);
export default SvgCurrencyPound;
